<template>
  <v-container
    fluid
    fill-height
    class="pa-0"
  >
    <v-slide-y-transition mode="out-in">
      <v-layout
        v-if="stroll"
        v-bind="binding"
      >
        <v-flex
          order-xs2
          order-md1
          order-lg1
          order-xl1
          md4
        >
          <v-card class="full-height">
            <image-with-fullscreen-dialog
              v-if="stroll.image_card"
              :fullscreen-image="stroll.image.meta.download_url"
              :preview-image="stroll.image_card.url"
              :title="stroll.title"
              :aspect-ratio="2"
            />
            <v-card-title>
              <span class="title font-weight-light">{{ stroll.title }}</span>
            </v-card-title>
            <v-card-text v-html="stroll.description" />

            <div v-if="stroll.preview_media">
              <v-card-title>
                <h3>Preview</h3>
              </v-card-title>
              <v-card-text>
                <div v-html="stroll.preview_description" />
                <media :media="stroll.preview_media" />
              </v-card-text>
            </div>

            <v-card-title v-if="stroll.checkpoints.length">
              <h3>{{ checkpointWordingPlural|capitalize }}</h3>
            </v-card-title>
            <v-list>
              <v-list-tile
                v-for="checkpoint of stroll.checkpoints"
                :key="checkpoint.id"
                @click="$router.push({name: 'checkpoint', params: {strollId: stroll.id, checkpointId: checkpoint.id}})"
              >
                <v-list-tile-action>
                  <v-icon>place</v-icon>
                </v-list-tile-action>
                {{ checkpoint.name }}
              </v-list-tile>

            </v-list>
          </v-card>
        </v-flex>
        <v-flex
          md-8
          order-xs1
          order-sm1
          order-md2
        >
          <l-map
            :center="center"
            :options="mapOptions"
            :zoom="zoom"
          >
            <l-tile-layer
              :url="url"
              :attribution="attribution"
              :options="{useCache: true}"
            />
            <l-circle-marker
              v-if="location"
              :lat-lng="[location.latitude, location.longitude]"
              :radius="6"
              :fill="true"
              :fill-opacity="0.3"
            />
            <l-marker
              v-for="checkpoint in stroll.checkpoints"
              :key="checkpoint.id"
              :title="checkpoint.name"
              :lat-lng="checkpoint.point.coordinates"
              @click="clickMarker(checkpoint)"
            />
            <l-control-zoom :position="zoomPosition" />
          </l-map>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ImageWithFullscreenDialog from '@/components/ImageWithFullscreenDialog.vue'
import Media from '@/components/Media.vue'
import StrollMixin from '@/mixins/StrollMixin'
import StrollInPersonMessage from '@/components/StrollInPersonMessage.vue'

export default {
  name: 'Stroll',

  mixins: [StrollMixin],

  components: {
    ImageWithFullscreenDialog,
    Media,
    StrollInPersonMessage,
  },

  computed: {
    ...mapGetters({
      checkpointWordingPlural: 'getCheckpointWordingPlural',
    }),

    binding () {
      const binding = {column: true}

      if (this.$vuetify.breakpoint.mdAndUp) {
        binding.column = false
      }

      return binding
    },
  },

  methods: {
    ...mapMutations([
      'setActiveCheckpoint',
    ]),

    clickMarker(checkpoint) {
      this.activeCheckpoint = checkpoint
      this.$router.push({
        name: 'checkpoint',
        params: {
          strollId: this.strollId,
          checkpointId: checkpoint.id
        },
      })
    },
  },
}
</script>

<style scoped>
.vue2leaflet-map.leaflet-container {
  min-height: 250px;
  height: 100%;
}
</style>
